import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  empty: (backgroundColor?: string) => FelaCSS;
}

const styles: IStyles = {
  empty: (backgroundColor = colors.white) => ({
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    supportsSafeAreaInset: {
      paddingTop: 'env(safe-area-inset-top)',
    },
    backgroundColor,
  }),
};

export default styles;
